import { render, staticRenderFns } from "./AniGroupList.vue?vue&type=template&id=9b95638a&scoped=true&"
import script from "./AniGroupList.vue?vue&type=script&lang=js&"
export * from "./AniGroupList.vue?vue&type=script&lang=js&"
import style0 from "./AniGroupList.vue?vue&type=style&index=0&id=9b95638a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b95638a",
  null
  
)

component.options.__file = "AniGroupList.vue"
export default component.exports